import { sendersService } from '@/features/senders/services/senders.service';
import { UpdateConfigurationDto } from '@/features/senders/types/sender.types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

// Hook pour créer une configuration de sender
export const useCreateSenderConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sendersService.createConfiguration,
    onSuccess: (_data, _variables) => {
      // Invalider toutes les queries liées aux domaines et dossiers
      queryClient.invalidateQueries({ queryKey: ['domains'] });
      queryClient.invalidateQueries({ queryKey: ['folder'] });
      toast.success('Configuration de sender créée avec succès');
    },
    onError: (error: HttpApiError) => {
      toast.error(
        error.response?.data?.message ||
          'Échec de la création de la configuration'
      );
    },
  });
};

// Hook pour mettre à jour une configuration de sender
export const useUpdateSenderConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      uuid,
      data,
    }: {
      uuid: string;
      data: UpdateConfigurationDto;
    }) => sendersService.updateConfiguration(uuid, data),
    onSuccess: () => {
      // Invalider toutes les queries liées aux domaines et dossiers
      queryClient.invalidateQueries({ queryKey: ['domains'] });
      queryClient.invalidateQueries({ queryKey: ['folder'] });
      toast.success('Configuration de sender mise à jour avec succès');
    },
    onError: (error: HttpApiError) => {
      toast.error(
        error.response?.data?.message ||
          'Échec de la mise à jour de la configuration'
      );
    },
  });
};
